(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  const stickyHeader = document.querySelector('sticky-header');
  if(!stickyHeader || stickyHeader == null){ 
    document.documentElement.style.setProperty('--header-height', `0px`);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olivan-hero-producto"] && !Shopify.designMode) return;
  try {
    
  /* Galería del hero: scroll-snap nativo + dots. Sin dependencias. */
  class OlivanGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.track || this.slides.length < 2) return;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
      });

      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = this.slides.indexOf(entry.target);
            this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('olivan-gallery')) customElements.define('olivan-gallery', OlivanGallery);

  /*
   * Barra fija inferior del hero.
   * - Visible cuando el bloque de compra ([data-olivan-buybox]) quedó por encima del viewport.
   * - Oculta mientras el footer está a la vista.
   * - El botón hace click en el botón real de "agregar al carrito" del hero (mismo flujo,
   *   mismos hooks de tema y apps). Si ese botón está oculto o reemplazado por un widget,
   *   lleva al usuario al bloque de compra.
   * - Precio: unitario × cantidad. Si Oxify publicó una oferta "quantity breaks" para este
   *   producto (window.listOfPublishedBundleSets, que el app embed de Oxify imprime en la
   *   página), refleja el tier seleccionado por defecto y los cambios al tocar el widget.
   *   Tipos de descuento soportados: no-discount, percentage, fixed-price (total del tier),
   *   fixed-amount. Cualquier otro tipo cae al precio base × cantidad.
   */
  class OlivanStickyBar extends HTMLElement {
    connectedCallback() {
      // <main> es un grid item con z-index 2 (crea stacking context) y el <footer> del tema es
      // position:relative; z-index:2 y viene después en el DOM: pintaría encima de la barra.
      // Fuera del editor, la barra se mueve a <body> para quedar en el stacking context raíz.
      const designMode = window.Shopify && window.Shopify.designMode;
      if (!designMode && this.parentElement !== document.body) {
        document.querySelectorAll('olivan-sticky-bar[data-moved="' + this.dataset.formId + '"]').forEach((el) => el.remove());
        this.dataset.moved = this.dataset.formId;
        document.body.appendChild(this); // vuelve a disparar connectedCallback, ya como hijo de <body>
        return;
      }
      this.buybox = document.querySelector(this.dataset.buybox);
      this.form = document.getElementById(this.dataset.formId);
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.metaEl = this.querySelector('[data-sticky-meta]');
      this.button = this.querySelector('[data-sticky-button]');
      this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
      this.qty = 1;
      this.tier = null;
      this.tiers = null;
      this.pastBuybox = false;
      this.footerVisible = false;
      if (!this.buybox || !this.button || !('IntersectionObserver' in window)) return;

      this.button.addEventListener('click', () => this.addToCart());
      this.setupVisibility();
      this.setupPriceSync();
      this.render();
    }

    disconnectedCallback() {
      if (this.buyboxObserver) this.buyboxObserver.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
      if (this.qtyObserver) this.qtyObserver.disconnect();
      if (this.oxifyObserver) this.oxifyObserver.disconnect();
    }

    setupVisibility() {
      // Se observa el botón de agregar al carrito (no todo el bloque de compra, que crece
      // cuando Oxify inyecta sus tiers): la barra aparece cuando el botón ya pasó hacia arriba.
      const submit = this.form ? this.form.querySelector('[type="submit"]') : null;
      const target = submit || this.buybox;
      // Si el header del tema es sticky, el botón "desaparece" al quedar debajo de él:
      // se descuenta su alto del área observada (equivale al rootMargin -80px del prototipo).
      const header = document.querySelector('.shopify-section-header-sticky, .shopify-section-group-header-group');
      const headerH = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
      this.buyboxObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          this.pastBuybox = !entry.isIntersecting && entry.boundingClientRect.bottom < headerH;
          this.update();
        },
        { rootMargin: `-${headerH}px 0px 0px 0px` }
      );
      this.buyboxObserver.observe(target);

      // Footer (opcional, setting "Ocultar al llegar al footer"): la barra se esconde solo
      // cuando el footer ya ocupa la mitad inferior de la pantalla (rootMargin -50%).
      const footer = document.querySelector('footer, .shopify-section-group-footer-group');
      if (footer && this.dataset.hideOnFooter === 'true') {
        this.footerObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;
            this.footerVisible = entry.isIntersecting;
            this.update();
          },
          { rootMargin: '0px 0px -50% 0px' }
        );
        this.footerObserver.observe(footer);
      }
    }

    update() {
      const show = this.pastBuybox && !this.footerVisible;
      this.dataset.visible = show ? 'true' : 'false';
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.button.tabIndex = show ? 0 : -1;
    }

    addToCart() {
      const submit = this.form ? this.form.querySelector('[type="submit"]') : null;
      const visible = submit && submit.offsetParent !== null && !submit.disabled;
      if (visible) {
        submit.click();
        return;
      }
      this.buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setupPriceSync() {
      if (this.form) {
        this.form.addEventListener('change', () => this.readQuantity());
        this.form.addEventListener('input', () => this.readQuantity());
        const qtyInput = this.form.querySelector('[name="quantity"]');
        if (qtyInput && 'MutationObserver' in window) {
          this.qtyObserver = new MutationObserver(() => this.readQuantity());
          this.qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
        }
      }

      if (this.dataset.syncOxify !== 'true') return;
      this.tiers = this.getOxifyTiers();
      if (this.tiers) {
        const preselected = this.tiers.find((t) => t.selectedByDefault);
        if (preselected) this.applyTier(preselected);
      }
      // El widget de Oxify se inyecta después de cargar la página, dentro del form
      // (#oxify-deal-block-<id> > .ia-card / .ia-card--selected). Se espera a que aparezca
      // y se observan los cambios de clase para seguir el tier elegido.
      let attempts = 0;
      const attach = () => {
        const block = document.querySelector('[id^="oxify-deal-block"]');
        if (!block) {
          if (attempts++ < 40) setTimeout(attach, 500);
          return;
        }
        if (!this.tiers) this.tiers = this.getOxifyTiers();
        this.detectOxifyTier();
        if ('MutationObserver' in window) {
          this.oxifyObserver = new MutationObserver(() => this.detectOxifyTier());
          this.oxifyObserver.observe(block, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
        }
      };
      attach();
      // Respaldo por si el widget cambia su estructura: cualquier click dentro de Oxify re-detecta.
      document.addEventListener(
        'click',
        (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target || !target.closest('[id^="oxify"], [class*="oxify"], .ia-card')) return;
          if (!this.tiers) this.tiers = this.getOxifyTiers();
          if (this.tiers) setTimeout(() => this.detectOxifyTier(), 60);
        },
        { passive: true }
      );
    }

    getOxifyTiers() {
      const sets = window.listOfPublishedBundleSets;
      const productId = String(this.dataset.productId || '');
      if (!Array.isArray(sets) || !productId) return null;
      const set = sets.find((candidate) => {
        if (candidate.published === false) return false;
        const products = (candidate.visibilitySettings && candidate.visibilitySettings.listOfSelectedProducts) || [];
        return products.some((p) => String(p.shortId || p.gId || '').endsWith(productId));
      });
      return set && Array.isArray(set.listOfDealTiers) ? set.listOfDealTiers : null;
    }

    detectOxifyTier() {
      if (!this.tiers) return;
      const root = document.querySelector('[id^="oxify-deal-block"]') || document.body;
      const card = root.querySelector('.ia-card--selected, [class*="card--selected"], [aria-checked="true"], [aria-selected="true"]');
      if (!card) return;
      // 1) Exacto: el radio oculto de la card lleva el id del tier de la oferta publicada.
      const radio = card.querySelector('input[type="radio"]');
      let tier = radio ? this.tiers.find((t) => String(t.id) === String(radio.value)) : null;
      // 2) Respaldo: por título.
      if (!tier) {
        const text = (card.textContent || '').replace(/\s+/g, ' ').trim();
        tier = this.tiers.find((t) => t.title && text.includes(String(t.title).trim()));
      }
      if (tier && tier !== this.tier) this.applyTier(tier);
    }

    applyTier(tier) {
      this.tier = tier;
      this.qty = Number(tier.quantity) || 1;
      this.render();
    }

    readQuantity() {
      const input = this.form ? this.form.querySelector('[name="quantity"]') : null;
      if (!input) return;
      const qty = parseInt(input.value, 10);
      if (!(qty > 0)) return;
      this.qty = qty;
      this.tier = this.tiers ? this.tiers.find((t) => Number(t.quantity) === qty) || null : null;
      this.render();
    }

    total() {
      const base = this.unitPrice * this.qty;
      const tier = this.tier;
      if (!tier) return base;
      const value = parseFloat(tier.discountValue) || 0;
      switch (tier.discountType) {
        case 'percentage':
          return Math.round(base * (1 - value / 100));
        case 'fixed-price':
          return Math.round(value * 100);
        case 'fixed-amount':
        case 'amount':
          return Math.max(0, base - Math.round(value * 100));
        default:
          return base;
      }
    }

    render() {
      if (this.priceEl) this.priceEl.textContent = this.formatMoney(this.total());
      if (this.metaEl) {
        const show = this.qty > 1;
        this.metaEl.hidden = !show;
        if (show) this.metaEl.textContent = (this.dataset.qtyText || 'x[n]').replace('[n]', String(this.qty));
      }
    }

    formatMoney(cents) {
      // Fallback al formato "amount" de Shopify. Se arma por concatenación porque theme-check
      // trata las llaves dobles literales dentro de este bloque como Liquid.
      const format = this.dataset.moneyFormat || '$' + '{' + '{amount}}';
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const type = match ? match[1] : 'amount';
      const value = cents / 100;
      const group = (n, sep) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      let text;
      switch (type) {
        case 'amount_no_decimals':
          text = group(Math.round(value), ',');
          break;
        case 'amount_with_comma_separator':
          text = group(Math.floor(value), '.') + ',' + (value % 1).toFixed(2).slice(2);
          break;
        case 'amount_no_decimals_with_comma_separator':
          text = group(Math.round(value), '.');
          break;
        case 'amount_with_apostrophe_separator':
          text = group(Math.floor(value), "'") + '.' + (value % 1).toFixed(2).slice(2);
          break;
        default:
          text = group(Math.floor(value), ',') + '.' + (value % 1).toFixed(2).slice(2);
      }
      // Mismo criterio que money_without_trailing_zeros en el hero.
      text = text.replace(/([.,])00$/, '');
      return format.replace(/\{\{\s*\w+\s*\}\}/, text);
    }
  }
  if (!customElements.get('olivan-sticky-bar')) customElements.define('olivan-sticky-bar', OlivanStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olivan-ugc-reels"] && !Shopify.designMode) return;
  try {
    
  /* Reels: play/pause al tocar, un solo video a la vez, pausa al salir del viewport. */
  class OlivanReels extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.olivan-reels__card--video'));
      if (!this.cards.length) return;
      this.playLabel = this.dataset.playLabel || '';
      this.pauseLabel = this.dataset.pauseLabel || '';
      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('.olivan-reels__play');
        if (!video || !button) return;
        video.removeAttribute('autoplay');
        button.addEventListener('click', () => this.toggle(card, video, button));
        video.addEventListener('click', () => this.toggle(card, video, button));
        video.addEventListener('pause', () => this.setState(card, button, false));
        video.addEventListener('play', () => this.setState(card, button, true));
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('video');
              if (video && !entry.isIntersecting && !video.paused) video.pause();
            });
          },
          { threshold: 0.3 }
        );
        this.cards.forEach((card) => this.observer.observe(card));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    toggle(card, video, button) {
      if (video.paused) {
        this.cards.forEach((other) => {
          const v = other.querySelector('video');
          if (v && v !== video && !v.paused) v.pause();
        });
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => this.setState(card, button, false));
      } else {
        video.pause();
      }
    }

    setState(card, button, playing) {
      card.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', playing ? 'true' : 'false');
      button.setAttribute('aria-label', playing ? this.pauseLabel : this.playLabel);
    }
  }
  if (!customElements.get('olivan-reels')) customElements.define('olivan-reels', OlivanReels);

  } catch(e) { console.error(e); }
})();
})();
